import { render, staticRenderFns } from "./home-zhuanti.vue?vue&type=template&id=2f92f608&"
import script from "./home-zhuanti.vue?vue&type=script&lang=js&"
export * from "./home-zhuanti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports